class NestedFieldSearchService {
  private static instance: NestedFieldSearchService;

  private settings = new Map<string, boolean>();

  private listeners = new Map<string, Set<(enabled: boolean) => void>>();

  static getInstance(): NestedFieldSearchService {
    if (!NestedFieldSearchService.instance) {
      NestedFieldSearchService.instance = new NestedFieldSearchService();
    }
    return NestedFieldSearchService.instance;
  }

  setSetting(key: string, enabled: boolean): void {
    this.settings.set(key, enabled);
    this.notifyListeners(key);
  }

  getSetting(key: string, defaultValue = true): boolean {
    return this.settings.get(key) ?? defaultValue;
  }

  getAllSettings(): Record<string, boolean> {
    return Object.fromEntries(this.settings);
  }

  subscribe(key: string, listener: (enabled: boolean) => void): () => void {
    if (!this.listeners.has(key)) {
      this.listeners.set(key, new Set());
    }
    const keyListeners = this.listeners.get(key)!;
    keyListeners.add(listener);

    return () => {
      keyListeners.delete(listener);
      if (keyListeners.size === 0) {
        this.listeners.delete(key);
      }
    };
  }

  private notifyListeners(key: string): void {
    const keyListeners = this.listeners.get(key);
    if (keyListeners) {
      const value = this.settings.get(key)!;
      for (const listener of keyListeners) listener(value);
    }
  }

  // Convenience methods for backward compatibility
  setSearchNestedFields(enabled: boolean): void {
    this.setSetting("searchNestedFields", enabled);
  }

  getSearchNestedFields(): boolean {
    return this.getSetting("searchNestedFields", true);
  }
}

export default NestedFieldSearchService;
